import script from "./UnderDevelopment.vue?vue&type=script&setup=true&lang=js"
export * from "./UnderDevelopment.vue?vue&type=script&setup=true&lang=js"

import "./UnderDevelopment.vue?vue&type=style&index=0&id=55b8ab3a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55b8ab3a"]])

export default __exports__